import desktop from './modules/desktop'

// eslint-disable-next-line
export default new Vuex.Store({
  modules: {
    desktop
  },
  strict: false
})